import { api } from 'app/config/apiConfig';
import { Pagination } from 'app/types/common';
import { ContractItemPriceRaise, ContractItemPriceRaiseStatus } from '../model/types';

interface Params {
  page?: number;
  limit?: number;
  orderBy?: string;
  warehouseId?: string | string[];
  contractId?: string;
  search?: string;
  status?: ContractItemPriceRaiseStatus | string;
  priceRaiseDateFrom?: string;
  priceRaiseDateTo?: string;
  nextReviewDateFrom?: string;
  nextReviewDateTo?: string;
  notificationSentAtFrom?: string;
  notificationSentAtTo?: string;
  isContractActive?: boolean;
}

export const getContractItemPriceRaisesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getContractItemPriceRaises: builder.query<Pagination<ContractItemPriceRaise>, Params>({
      query: (args) => ({
        url: '/contracts/price-raises',
        params: args,
      }),
      providesTags: ['Contract item price raises'],
    }),
  }),
});

export const { useGetContractItemPriceRaisesQuery } = getContractItemPriceRaisesApi;
